import __C from '../../../../../../includes/primitives/_constant_'

export default {
    Canvas: {
      CanvasWidth: 860,
      CanvasHeight: 300,
      CanvasBorderWeight: 0.1,
      CanvasBorderColor: '#bcbcbc',
      CanvasFillColor: 'Transparent',
      CanvasOpacity: 0.2,

      CanvasChartX: 0,
      CanvasChartY: 0,
      CanvasChartWidth: 1300,
      CanvasChartHeight: 760,
      CanvasChartBorderWeight: 0,
      CanvasChartBorderColor: '#757575',
      CanvasChartFillColor: '#757575',
      CanvasChartOpacity: 0,
      CanvasChartSpace: 0,

      CanvasFontFamily: 'roboto',
    },

    
    DataItems: [
      {title:"SH No.",value:"21-6600"},
      {title:"SH Description",value:"Emergency & Essential Power"},
      {title:"System No.",value:"21-6600-6676"},
      {title:"System Description",value:"Normal & Essential Lighting an"},
      {title:"Subsystem No.",value:"21-6600-6676-02"},
      {title:"Subsystem Description",value:"Normal Lighting Panel 02 (ROOM"},
      {title:"Priority",value:"P2"},
      {title:"Completion Lead",value:"F. Zhang"},
      {title:"Construction Lead",value:"C.Bosse / G.Lejosne"},
      {title:"Commissioning Lead",value:"Anis Ben Miled"},
      {title:"RFI",value:"2021-06-30"},
      {title:"WD Date",value:"2021-07-30"},
      {title:"WD Actual",value:"PENDING WALKDOWN"},
      {title:"MC Plan",value:"2021-08-13"},
      {title:"MC",value:"NOT STARTED"},
      {title:"MC Actual",value:"2021-05-30"},
      {title:"MC Approved",value:"2021-04-30"}
        
    ],
    

    Queries: {
      // ITR A Overall
      SQL1: [
        {TOTAL:57,ACTUAL:0,SIGNED: 80,REMAIN:57,PROG:0}
      ],
      // Punch Status
      SQL2:  [
        {CAT:"A",TOTAL:602,ACTUAL:20,REMAIN:582,PROG:3.32},
        {CAT:"B1",TOTAL:103,ACTUAL:1,REMAIN:102,PROG:0.97}
      ],
      // QCF
      SQL3: [
        {TOTAL:24,ACTUAL:0,SIGNED: 99,REMAIN:24,PROG:0}
      ],
      // Vendor
      SQL4: [
        {TOTAL:24,ACTUAL:0,SIGNED: 99,REMAIN:24,PROG:0}
      ]
    },
}